export default "__VITE_ASSET__BC5EGesd__"